import Twitter from "@/components/icons/Twitter"
import { SocialMediaLinks } from "@types"
import { Rss } from "lucide-react"
import { FaFacebook, FaGithub, FaInstagram } from "react-icons/fa"
import { FarcasterIconWithSuspense } from "./FarcasterIcon"
import { cn } from "@/lib/utils"

export default function SocialLinks({
  className,
  socials,
  walletAddress,
  blogUrl,
}: {
  className?: string
  socials?: SocialMediaLinks
  walletAddress?: string
  blogUrl?: string
}) {
  if (
    !socials?.facebook &&
    !socials?.farcaster &&
    !socials?.github &&
    !socials?.instagram &&
    !socials?.twitter &&
    !blogUrl
  ) {
    return null
  }

  return (
    <div
      className={cn(
        "flex flex-row gap-4 text-muted-foreground pb-2",
        className
      )}
    >
      {walletAddress && (
        <FarcasterIconWithSuspense walletAddress={walletAddress} />
      )}
      {socials?.twitter && (
        <a
          href={`https://x.com/${socials?.twitter}`}
          target="_blank"
          rel="noreferrer"
        >
          <Twitter className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.instagram && (
        <a
          href={`https://instagram.com/${socials?.instagram}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaInstagram className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.github && (
        <a
          href={`https://github.com/${socials?.github}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {socials?.facebook && (
        <a
          href={`https://facebook.com/${socials?.facebook}`}
          target="_blank"
          rel="noreferrer"
        >
          <FaFacebook className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
      {blogUrl && (
        <a
          href={`https://paragraph.com/api/blogs/rss/${blogUrl}`}
          target="_blank"
          rel="noreferrer"
        >
          <Rss className="h-5 w-5 transition-all hover:text-slate-700" />
        </a>
      )}
    </div>
  )
}
